var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiSkeletonElement',{style:({
    height: '64px',
    width: '100%',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }